<template >
  
  <main>
   <van-form @submit="onSubmit">
   <van-nav-bar
        title="非单位收款"
        left-text="保存"
        right-text="清空"
        @click-left="save()"
        @click-right="clearForm()"
      />
     <van-field
                    v-model.trim="form.customerName"
                          maxlength="50"
                          show-action
                          required
                            label="店铺名称"
                          @blur="nameSyn"
                          :rules="[{ required: true, message: '请填写店铺名称' }]"
                          placeholder="请输入店铺名称">
                        <template #button>
                        <van-icon name="search" @click="searchCustomer()" />
                      </template>              
       </van-field> 


         <van-field
      v-model.trim="form.corpName"
      name="corpName"
      required
        clearable
      maxlength="80"
      label="购方名称"
      placeholder="购方名称"
      :rules="[{ required: true, message: '请填写购方名称' }]"
    />

      <van-field
      v-model.trim="form.corpNsrsbh"
      name="corpNsrsbh"
      maxlength="20"
      label="购方税号"
      placeholder="购方税号"/>

      <van-field
                    v-model.trim="form.khlx"
                          maxlength="50"
                          show-action
                          is-link
                          readonly
                          required
                           :rules="[{ required: true, message: '请填写客户类型' }]"
                            label="客户类型"
                             @click="searchCategory()"
                          placeholder="请选择客户类型">
                        <!-- <template #button>
                        <van-icon name="search" @click="searchCategory()" />
                      </template>               -->
       </van-field>  

     <van-field
      v-model.trim="form.zcdz"
      name="address"
      is-link
      readonly
      required
      :rules="[{ required: true, message: '请填写客户街道' }]"
      label="客户街道"
      placeholder="客户街道"
      @click="setAddRessOpen()"
  />

  <van-popup v-model="addressShow" round position="bottom">
    <van-cascader
        ref="selectFiles" 
        v-model.trim="zcdzSelect"
        title="所在街道"
        :options="addressOptions"
        @close="addressShow = false"
        @change="onAddressChange"
        @finish="onAddressFinish"
    />

     </van-popup>

       <van-field
        clearable
        v-model="form.address"
         maxlength="100"
          required
         :rules="[{ required: true, message: '请填写详细地址' }]"
        name="address"
        label="详细地址"
        placeholder="详细地址" />

        
         <van-field
        clearable
        v-model="form.skuTitle"
        name="skuTitle"
         is-link
         readonly
           required
        :rules="[{ required: true, message: '请选择收费标准' }]"
        label="收费标准"
        @click="showSkuOperator"
        placeholder="收费标准" />

         <!-- <van-field
          v-model="paymentDuration"
          readonly
          name="paymentDuration"
          label="缴费时长"
          placeholder="缴费时长" /> -->

        <van-field
          v-model="form.price"
          readonly
          v-show="showPrice"
          name="price"
          type="number"
          label="单价"
          placeholder="单价" />

      <van-field name="quantity"  type="digit" required  @blur="setTotalPrice"
          v-model="form.quantity"  label="缴费月份数">
      </van-field>  


          <van-field
        clearable
        v-model="form.totalPrice"
        name="totalPrice"
        maxlength="20"
        :readonly="status?false:'readonly'"
        label="总金额"
        type="number"
          required
        placeholder="总金额" >

            <div slot="label" class="flex">
                    <span  style="color:red">总金额</span>
                </div>
          </van-field>

           <van-field
        clearable
        v-model="form.email"
        name="email"
        maxlength="50"
        label="收票邮箱"
        placeholder="收票邮箱" />



        <van-field
        clearable
        v-model="form.waterMeterNo"
        name="waterMeterNo"
        maxlength="20"
         type="digit"
        label="水表号"
        placeholder="水表号" />

 <van-field
        clearable
        v-model="form.customerPhone"
        name="customerPhone"
        label="手机号码"
        maxlength="11"
        placeholder="手机号码" />
       

       <van-field
        clearable
        v-model="form.landlordSname"
        name="landlordSname"
        maxlength="20"
        label="房东姓名"
        placeholder="房东姓名" />

         <van-field
        clearable
        v-model="form.landlordTelephone"
        name="landlordTelephone"
        maxlength="11"
         type="digit"
        label="房东电话"
        placeholder="房东电话" />

       

    <van-field
        clearable
        v-model="form.remarks"
        name="remarks"
        rows="2"
        autosize
        type="textarea"
        label="发票备注"
        placeholder="发票备注" />

    <div style="margin-bottom: 60px">
        <van-button round block type="primary" native-type="submit">
      提交
    </van-button>
      </div>

   </van-form>  

  <div class="selector">  <!-- 选择客户-->
    <van-popup v-model="showPicker" position="bottom" >
        <van-search  v-model="searchText" placeholder="搜索" @input="onSearch"> </van-search>
         <van-picker show-toolbar :columns="showOptions" @confirm="onConfirm"  value-key="khName"
          @cancel="close" @change="onChange">

           <template #option="option">
              <div style="display: flex; flex-direction: column; align-items: center; text-align:center">
                <div>{{ option.unitName }}/{{ option.dzXxdz }}</div>
              </div>
            </template>

         </van-picker>
    </van-popup> 
  </div>

   <div class="selector">  <!-- 选择客户类别--> 
    <van-popup v-model="showPickerCategory" position="bottom" >
    <van-cascader
        v-model="cascaderValue"
        title="请选择客户类别"
          :field-names="fieldNames"
          active-color="#1989fa"
        :options="categoryOptions"
        @close="showPickerCategory = false"
        @finish="onFinish"
      />
    </van-popup> 
  </div>

  
 <div class="selector">   <!-- 选择收费标准--> 
    <van-popup v-model="skuShow" position="bottom" >
    <van-picker show-toolbar :columns="sku" @confirm="onConfirmSku"  value-key="id"
          @cancel="closeSku" @change="onChangeSku">


          <template #option="option">
              <div style="display: flex; flex-direction: column; align-items: center;">
                <div>{{ option.skuTitle }}</div>
              </div>
            </template>
        
    </van-picker>
    </van-popup> 
  </div>



       

  </main>

</template>
<script>
import {Indicator} from "mint-ui";
import {
  Card,
  Cell,
  CellGroup,
  Col,
  Dialog,
  Divider,
  Icon,
  Image,
  List,
  Panel,
  Row,
  Swipe,
  SwipeItem,
  Tab,
  Form,
  Tabbar,
  TabbarItem,
  Tabs,
  Toast,
  Search,
  Field,
  Picker,
  TreeSelect,
  Cascader,
  DropdownMenu,
   DropdownItem,
   Stepper,
   RadioGroup, Radio
} from "vant";

export default {
  components: {
      [DropdownMenu.name]: DropdownMenu,
     [DropdownItem.name]: DropdownItem,
     [TreeSelect.name]: TreeSelect,
    [Cascader.name]: Cascader,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Card.name]: Card,
     [Picker.name]:Picker,
     [Search.name]: Search,
    [Toast.name]: Toast,
    [Form.name]:Form,
    [Divider.name]: Divider,
    [List.name]: List,
    [Panel.name]: Panel,
    [Image.name]: Image,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Field.name]:Field,
     [Radio.name]:Radio,
     [RadioGroup.name]:RadioGroup,
      [Stepper .name]:Stepper,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      status:false,
      showPrice:false,
      radio:'',
      showPickerCategory:false,
       items:[],
       categoryOptions:[],
      activeId: 1,
      activeIndex: 0,
      searchText:'',
      customerName:'',
      customerId:'',
      corpNsrsbh:'',
      showOptions: [],
      options: [],
      sku:[],
      sysarea: {parentId:'350800',delFlag:'0'},
       value1:'',
      addDetailsVisable:false,
      orderDetailsList:[],
      showPicker:false,
      categoryShow:false,
      skuName:'',
      cascaderValue:'',
       fieldNames: {
        text: 'label',
        value: 'id',
        children: 'children',
      },
     addressOptions:[
     ],
     skuShow:false,
     addressShow:false,
     dzShreet:'',
     zcdzSelect:'',
     paymentDuration:'1年(12月)',
      form:{
        corpName:'',  //购方名称
        customerName:'',
        customerId:'',
        khlx:'',
        khCustkind:'',
        industryId:'',
        skuTitle:'',
        skuId: '',   //sku
        customerPhone:'',//电话
        zcdz:'',   //区和街道
        dzCounty:'',  //区
        dzShreet:'',  //街道
        categoryId:'',
         price:1,
        quantity:12,
         priceFlag:1,
         totalPrice:"",
         skuStartquan:0,
         skuEndquan:0,
         landlordTelephone:'',
         landlordSname:'',
        email:'',
        spClass:'', //商品类别 
        remarks:'',  //备注
        address:'',    //详细地址
        waterMeterNo:'' //水表号
      },
      orderDetailForm :
      {
      categoryId: '',  //商品类别Id
       id:-1,  //skuId
      goodName:'',
      taxRate:'6%',
      price:1,
      quantity:1,
      priceFlag:1,
      totalPrice:1,
      specifications:'',
      units:'',
      },
    };
  },
  created() {
       this.init();
  },  //创建事件
  methods: {

    setTotalPrice(){

           if(this.form.quantity<=0){
             this.form.quantity=1;
           }
           this.form.totalPrice= this.form.price*this.form.quantity;
    },
     //默认选择新罗区
    setAddRessOpen(){

        this.addressShow=true;
        this.zcdzSelect='350802';
          this.$axios
          .get('/memberBusiness/sysArea/sysareaList', {parentId:'350802',delFlag:'0'})
          .then((data) => {
           this.addressOptions[0].children = [];
            data.obj.forEach((a)=>{
               this.addressOptions[0].children.push({text:a.name,value:a.id})
            })
           
          })
          .catch(
              function (response) {
                this.$message.error('操作失败请重试');
              }.bind(this)
          );
    },


    nameSyn(){   //关联单位
       

       this.form.corpName=this.form.customerName;

    }, 
    clearForm(){   //关闭单位

       this.form.customerId=null;
       this.form.customerName='';
       this.form.corpName='';
       this.form.khlx='';
       this.form. khCustkind='';
        this.form. industryId='';
        this.form. skuTitle='';
        this.form. skuId='';
        this.form. customerPhone='';
         this.form.zcdz='';
        this.form. dzCounty='';
         this.form.dzShreet='';
        this.form. categoryId='';
         this.form. price='';
        this.form. quantity='';
         this.form. priceFlag='';
         this.form. totalPrice='';
        this.form.  skuStartquan='';
         this.form. skuEndquan='';
         this.form. landlordTelephone='';
         this.form. landlordSname='';
         this.form.email='';
         this.form.remarks='';
         this.form.address='';
         this.form.waterMeterNo='';
    },
    operatorQuantity(){  //编辑数量事件
    if(this.form.priceFlag=='1'){  //固定数量 
      this.form.totalPrice= this.form.price*this.form.quantity;
    
    }else if(this.form.priceFlag=='3'){ //递增
       this.form.price= this.form.price*1+1;
        this.form.totalPrice= this.form.price*
          this.form.quantity;
    }else if(this.form.priceFlag=='2'){  //如果是阶梯

        for(let x in  this.sku){
          if( this.form.quantity<=this.sku[x].skuEndquan&&
            this.form.quantity>=this.sku[x].skuStartquan ){
            this.form.price=this.sku[x].skuPrice;
            this.form.totalPrice= this.form.price*
            this.form.quantity;
            this.form.skuId=this.sku[x].id;
            this.form.skuTitle=this.sku[x].skuTitle;
          }

        }
    }
},
 

    closeSku(){   //关闭事件

      this.skuShow=false;

    },

    onChangeSku(value, index){  //修改sku

        this.form.skuTitle=value.skuTitle;
         this.form.skuId=value.id;
         this.form.price=value.skuPrice;
          this.form.skuStartquan=value.skuStartquan;
          this.form.skuEndquan=value.skuEndquan;
       
         this.form.priceFlag=value.priceFlag;
         if(this.form.priceFlag=='3'){
            this.status=true;
            this.form.quantity=1;
         }
           this.form.totalPrice= this.form.price*this.form.quantity;

    },
    onConfirmSku(value, index){  //确认sku
         // console.log(value);
         this.form.skuTitle=value.skuTitle;
         this.form.skuId=value.id;
        //  alert(this.form.skuId);
         this.form.price=value.skuPrice;
          this.form.skuStartquan=value.skuStartquan;
          this.form.skuEndquan=value.skuEndquan;
          if(this.form.skuId==294){
               this.form.quantity=1;
          }
        
         this.form.priceFlag=value.priceFlag;
         this.skuShow=false;
         if(this.form.priceFlag=='3'){
            this.status=true;
             this.form.quantity=1;
         }
          this.form.totalPrice= this.form.price*this.form.quantity;
    },

    showSkuOperator(){   //打开sku窗体

     if(this.form.industryId==''){
         Toast('请选择客户类型');
     }else{

      const url = "/index/"+this.form.industryId+"/selectSku";
      this.$axios
        .get(url)
        .then((data) => {
          this.sku=data.data;

          this.skuShow=true;
       
        })
        .catch((error) => {
          //请求失败返回的数
          Toast({
            message: error.message,
            position: "middle",
            duration: 2000,
          });
        });
     }

    },

    onAddressChange(item){  //地址

    console.log(item);

      this.$axios
          .get('/memberBusiness/sysArea/sysareaList', {parentId:item.selectedOptions[0].value,delFlag:'0'})
          .then((data) => {
            const children = [];
            data.obj.forEach((a)=>{
              children.push({text:a.name,value:a.id})
            })
            console.log(item.selectedOptions[0].children=children)
          })
          .catch(
              function (response) {
                this.$message.error('操作失败请重试');
              }.bind(this)
          );
    },
    onFinish({selectedOptions}){  //选择客户类别 
    
      this.showPickerCategory = false;
      this.form.khlx=selectedOptions.map((option) => option.label).join('/');
      // console.log(this.form.khlx);

      console.log(selectedOptions[0]);
      this.form.khCustkind = selectedOptions[0].id;
      this.form.industryId = selectedOptions[1].id;
      // console.log(this.form.industryId);

      this.form.skuId='';
      this.form.skuTitle='';
        
   },
    onAddressFinish({selectedOptions}){   //选择地址

      this.form.address=selectedOptions.map((option) => option.text).join('/');
      this.form.zcdz=selectedOptions.map((option) => option.text).join('/');
     // console.log(this.form.zcdz);
      this.form.dzCounty = selectedOptions[0].value;  //区Id
      this.form.dzShreet = selectedOptions[1].value;  //街道Id
      this.addressShow=false;
    },

     init(){   //初始化
      var that = this;
      this.$axios
          .get('/memberBusiness/sysArea/sysareaList',this.sysarea)
          .then((data) => {
            console.log(data)
            data.obj.forEach((a)=>{
              that.addressOptions.push({text:a.name,value:a.id,children:[]})
            })
            //  console.log(1);
            //  console.log(that.addressOptions);
          })
          .catch(
              function (response) {
                // this.$message.error('操作失败请重试');
              }.bind(this)
          );

        if(localStorage.getItem("sessionOrder")!=null){

           this.form=JSON.parse(localStorage.getItem("sessionOrder"));

        }


     },

   onSubmit(){   //提交订单 


      if(this.form.customerName==''){
         Toast('请输入客户名称');
         return ''
      }
      if(this.form.khlx==''){
         Toast('请输入客户类型');
         return ''
      }
      if(this.form.totalPrice==''){
         Toast('请输入价格');
         return ''
      }
      if(this.form.totalPrice*1<0){
          Toast('金额有误');
           return ''
      }
      if(this.form.priceFlag=='3') {
        this.form.price=this.form.totalPrice/this.form.quantity;
        const r = /^\+?[1-9][0-9]*$/;
          if (!r.test(this.form.price)) {
            Toast('金额有误');
            return ;
          } 
      }
       var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      var reg_email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if(this.form.email!=''){
          if(!reg_email.test(this.form.email)){
            Toast('邮箱格式异常')
                return ''
        }
      }
    
        if(this.form.customerPhone!==''){
        if(!reg_tel.test(this.form.customerPhone)){
             Toast('手机号格式异常');
              return ''
        }
      }
        if(this.form.landlordTelephone!==''){
        if(!reg_tel.test(this.form.landlordTelephone)){
             Toast('房东手机号格式异常');
              return ''
        }
      }
       console.log(this.form.corpNsrsbh);
       if(this.form.corpNsrsbh!=''&&this.form.corpNsrsbh!=undefined){
          let  nsrsbhlen=this.form.corpNsrsbh.length;
          if(!(nsrsbhlen==15||nsrsbhlen==18||nsrsbhlen==20)){
              Toast('税号格式异常为15位18位或20位,当前长度为:'+nsrsbhlen);
              return ''
          }
       }
      Indicator.open({
        text: "提交中...",
        spinnerType: "fading-circle"
      });
      let orderId=this.randomNumber();
      console.log(orderId);
      if(this.form.skuId==294){
         this.form.quantity=1;
       }
      this.orderDetailsList=[];
      let orderDetails={

           shuliang:this.form.quantity,
           skuId:this.form.skuId,
           je:this.form.price,
           orderZje:this.form.totalPrice

      };

      this.orderDetailsList.push(orderDetails);
      this.form.orderCode=orderId;
      this.form.orderDetailsList=this.orderDetailsList;
      this.form.orderZje=this.form.totalPrice;
      
      var url = "/memberBusiness/order/addOrdersNew";  //提交订单
       this.$axios
          .post(url, this.form)
          .then((res) => {
            console.log('返回')
            console.log(res)
            if (res.code == 200) {
                let resultOrderId=res.data;
                sessionStorage.setItem("orderZje",this.form.totalPrice);
                localStorage.removeItem("sessionOrder");//提交之后删除
                this.$router.push({
                path: '/collection',
                query: {
                  orderId: resultOrderId,
                },
              });
              Indicator.close();
            }else{
              Toast(res.message);
               Indicator.close();
            }
          })
    },

      addZero(s) {
      return s<10?('0'+s):s;
      },
  searchCategory(){  //选择客户类别
    const url = "/index/tree";
    this.$axios
      .get(url)
      .then((data) => {
        this.categoryOptions = JSON.parse(data.data);
         this.showPickerCategory=true;
      })
      .catch((error) => {
        //请求失败返回的数
        Toast({
          message: error.message,
          position: "middle",
          duration: 2000,
        });
      });

  },
   
     onChange(picker, value, index){   //选择客户改变事件

        if(value==undefined){
          return ;
        }
        this.form.customerName=value.unitName;
        this.form.corpName=value.khName; //购方名称
        this.form.customerId=value.id;
        this.form.corpNsrsbh=value.khNsrsbh;
        this.form.khlx=value.khlx+"/"+value.industry;
        this.form.khCustkind=value.khCustkind;
        this.form.industryId=value.industryId;
        this.form.zcdz=value.zcdz;    //街/区合并
        this.form.dzCounty=value.dzCounty;
        this.form.dzShreet=value.dzShreet;
        this.form.address=value.dzXxdz; //详细地址 
        this.form.customerPhone=value.phone;
        this.form.quantity=value.shopArea;
        this.form.totalPrice=value.money;
        this.form.price=this.form.totalPrice*1/this.form.quantity;
        this.form.landlordSname=value.landlordSname;
        this.form.landlordTelephone=value.landlordTelephone;
        this.form.email=value.mail;
        this.form.waterMeterNo=value.waterMeterNo;
        this.form.remarks=value.remarks;
        this.form.totalPrice=value.money;

       //根据类别Id,查找出sku,数量定位

      const url = "/index/"+this.form.industryId+"/selectSku";
      this.$axios
        .get(url)
        .then((data) => {
          this.sku=data.data;
          
          for(let x in  this.sku){
          if(this.form.totalPrice*1/this.form.quantity==this.sku[x].skuPrice){
                  this.form.price=this.sku[x].skuPrice;
                  this.form.skuId=this.sku[x].id;
                  this.form.skuTitle=this.sku[x].skuTitle;
          }

        }

        
        })
        .catch((error) => {
          //请求失败返回的数
          Toast({
            message: error.message,
            position: "middle",
            duration: 2000,
          });
        });



    },
    onConfirm(value, index){   //客户确认事件
        if(value==undefined){
          return ;
        }
        console.log(value);
        this.form.customerName=value.unitName;
        this.form.corpName=value.khName;  //购方名称
        this.form.customerId=value.id;
        this.form.corpNsrsbh=value.khNsrsbh;
        this.form.khlx=value.khlx+"/"+value.industry;
        this.form.khCustkind=value.khCustkind;
        this.form.zcdz=value.zcdz;    //街/区合并
        this.form.industryId=value.industryId;
        this.form.dzShreet=value.zcdz;
        this.form.address=value.dzXxdz;
        this.form.customerPhone=value.phone;
        this.form.quantity=value.shopArea;
        if(this.form.quantity==null){
           this.form.quantity=12;  //默认12
        }
        this.form.totalPrice=value.money;
        this.form.price=this.form.totalPrice*1/this.form.quantity;
        this.form.landlordSname=value.landlordSname;
        this.form.landlordTelephone=value.landlordTelephone;
        this.form.email=value.mail;
        this.form.waterMeterNo=value.waterMeterNo;

        this.form.remarks=value.remarks;
        this.form.totalPrice=value.money;

       //根据类别Id,查找出sku,数量定位
      const url = "/index/"+this.form.industryId+"/selectSku";
      this.$axios
        .get(url)
        .then((data) => {
          this.sku=data.data;
          for(let x in  this.sku){
              if(this.form.totalPrice/this.form.quantity==this.sku[x].skuPrice){
                  this.form.price=this.sku[x].skuPrice;
                  this.form.skuId=this.sku[x].id;
                  this.form.skuTitle=this.sku[x].skuTitle;
              }
          }
        })
        .catch((error) => {
          //请求失败返回的数
          Toast({
            message: error.message,
            position: "middle",
            duration: 2000,
          });
        });
        this.showPicker=false;
    },
    close(){   //关闭弹窗
          
        this.showPicker=false;

    },
    onSearch(){  //内置的查询事件

     if (this.searchText === '' || this.searchText === null) {
        this.showOptions = this.options;
      } else {
             this.showOptions = this.options.filter((e) => e.unitName.toLowerCase().indexOf(
             this.searchText.toLowerCase()) != -1||e.dzXxdz.toLowerCase().indexOf(
             this.searchText.toLowerCase()) != -1)
      }

    },

    
    searchCustomer(){   //搜索事件打开弹出层

    
   if(this.form.customerName==''){

       Toast("请输入名称后再进行搜索");

     return;
   }

    const url = "/index/customerList";
    this.$axios
     .get(url, {whetherUnits:"0",unitName:this.form.customerName})
      .then((data) => {
        this.showOptions = data.data;
        this.options=data.data;
         this.showPicker=true;
         this.searchText=this.form.customerName;
      })
      .catch((error) => {
        //请求失败返回的数
        Toast({
          message: error.message,
          position: "middle",
          duration: 2000,
        });
      });

    },

   save(){

    //  console.log(1)
     localStorage.setItem("sessionOrder",JSON.stringify(this.form));
      Toast('保存成功');

   },
    back(){
      localStorage.removeItem("sanitationAccessToken")
      localStorage.removeItem("sanitationUsername")
      this.$router.push({path: '/login'})
    },
   
  },
};
</script>

<style lang="less" scoped>
img {
  width: 100%;
  height: 100%;
}
.my-swipe .van-swipe-item {
  color: #fff;
}
.test {
  line-height: 100px;
  background-color: #39a9ed;
}
.index {
  .subject {
    padding: 0px 0px 5px 0px;
    .text {
      display: none;
      width: 100%;
      padding: 5px;
      position: absolute;
      z-index: 10;
      margin-top: -32px;
      background-color: #979595;
      color: #ffffff;
      font-size: 12px;
      opacity: 0.8;
    }
  }

  .van-card {
    background-color: #ffffff;
  }

  .typebox{ overflow:hidden;background-color: #5baa3c;margin: 6px;border-radius: 6px;}
  .typebox ul{ overflow:hidden; padding:15px 0}
  .typebox ul li{ float:left; width:33%;}
  .typebox ul li img{ display:block; margin:0 auto; width: 75px; height:75px;}
  .typebox ul li p{ text-align:center;  font-size:16px; letter-spacing:1px;color: rgb(255, 255, 255);}
}
.searchForDate {
        z-index: 1000;
        width: 90%;
        height: 11rem;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        transform: translate3d(0,0,0);
    }
</style>
